<script>
export default {
  data: () => ({
    sort: {
      sortBy: "id",
      sortOrder: "ASC"
    }
  }),
  methods: {
    changeSort(sortName, name, sortable) {
      if (sortable ?? true) {
        var field = sortName ?? name;
        if (field == this.sort.sortBy) {
          this.sort = {
            sortBy: field,
            sortOrder: this.sort.sortOrder == "ASC" ? "DESC" : "ASC"
          };
        } else {
          this.sort = {
            sortBy: field,
            sortOrder: "ASC"
          };
        }
      }
    },
    showSortDown(sortName, name, sortable) {
      if (sortable ?? true) {
        var field = sortName ?? name;
        return field == this.sort.sortBy && this.sort.sortOrder == "DESC"
          ? true
          : false;
      } else {
        return false;
      }
    },
    showSortUp(sortName, name, sortable) {
      if (sortable ?? true) {
        var field = sortName ?? name;
        return field == this.sort.sortBy && this.sort.sortOrder == "ASC"
          ? true
          : false;
      } else {
        return false;
      }
    },
    showSortNone(sortName, name, sortable) {
      if (sortable ?? true) {
        var field = sortName ?? name;
        return field == this.sort.sortBy ? false : true;
      } else {
        return false;
      }
    }
  }
};
</script>
